<template>
  <div class="container_box">
    <!--tab栏-->
    <Tabs v-model="packagingTab" :animated="false" @on-click="changeTab">
      <TabPane :label="$t('key1004702')" name="conventionalPackaging"></TabPane>
      <TabPane :label="$t('key1004703')" name="stockUpPackaging"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <span>{{ $t('key1004709') }}</span>
      <Input v-model.trim="pickList" :element-id="'packaging'" style="width:300px;" clearable @on-enter="pickStart"></Input>
    </div>
    <template v-if="getPermission('ymsPickingOrder_queryPackingListByParam')">
      <div class="filter_box">
        <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
          <Row type="flex" :gutter="gutterItem">
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1004704')">
                <local-tabButton :tabButtonList="pickingStatusList" @selectStatus="pickingStatusBtn"></local-tabButton>
              </FormItem>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1002399')" prop="ymsWarehouseId">
                <Select v-model="pageParams.ymsWarehouseId" filterable>
                  <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
                </Select>
              </Form-item>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1004705')" prop="operatorId">
                <Select v-model="pageParams.operatorId" filterable>
                  <Option v-for="item in updatedByList" :key="item.userId" :value="item.userId">{{ item.userName }}</Option>
                </Select>
              </Form-item>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <dropDownDateTime
                :transfer="false"
                ref="dropDownDateTime"
                :dropDownTimeList="dropDownTimeList"
                :defaultSelectValue="defaultSelectTimeValue"
                @changeInput="changeTimeInput"
                @selectTime="selectTime"
                @resetTime="resetTime">
              </dropDownDateTime>
            </Col>
            <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1004706')" prop="codes">
                <Input type="textarea" :placeholder="$t('key1004707')" v-model.trim="pageParams.codes"></Input>
              </Form-item>
            </Col>
            <Col style="min-width: 200px;" push="1">
              <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
              <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
            </Col>
          </Row>
        </Form>
      </div>
      <!--功能按钮操作区域-->
      <div class="operation_box">
        <!--导出数据-->
        <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsPickingOrder_exportPackingListByParam')">
          <Button type="primary">
            <span>{{ $t('key1003082') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <!--列表区域-->
      <div class="table_box">
        <Table
          ref="selection"
          highlight-row
          border
          max-height="520"
          :loading="tableLoading"
          :columns="tableColumns"
          @on-selection-change="tableChange"
          :data="tableData">
        </Table>
        <Page
          :transfer="true"
          v-if="!tableLoading"
          :total="total"
          @on-change="changePage"
          show-total
          :page-size="pageParams.pageSize"
          show-elevator
          :current="pageParams.pageNum"
          show-sizer
          @on-page-size-change="changePageSize"
          placement="top"
          :page-size-opts="pageArray">
        </Page>
      </div>
      <!--导出订单字段弹窗-->
      <exportFieldsModal
        ref="exportFields"
        :exportFieldsTitle="$t('key1004708')"
        paramKeyColums="ymsPickingOrderPackingHandlerColumns"
        :customFieldExportList="customFieldExportList"
        @exportFieldsDataBtn="exportFieldsDataBtn">
      </exportFieldsModal>
    </template>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import dropDownDateTime from "@/components/common/dropDownDateTime.vue";
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import {
  getUserNameByUserId, pageJump, setConfigCharacters, getYmsUserWarehouseOpersUserName,
  getEnableWarehouseData, getWarehouseName, getAllUsersInfo, getDataSetBatchList, getEnumName
} from "@/utils/common";

export default {
  components: {exportFieldsModal, dropDownDateTime},
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pickList: '', // 拣货单单号
      packagingTab: 'conventionalPackaging',
      warehouseList: [],
      updatedByList: [],
      total: 0,
      pageParams: {
        sortedStartTime: null, // 拣货/分拣完成--开始时间
        sortedEndTime: null, // 拣货/分拣完成--结束时间
        beginPackingStartTime: null, // 开始作业--开始时间
        beginPackingEndTime: null, // 开始作业--结束时间
        closePackingStartTime: null, // 结束作业--开始时间
        closePackingEndTime: null, // 结束作业--结束时间
        packingType: 1, // 包装作业的类型 1:常规包装 2:备货包装
        codes: '',
        operatorId: 'null',
        status: null,
        ymsWarehouseId: 'null',
        pageNum: 1,
        pageSize: 15,
      },
      pickingStatusList: [ // 3:待分拣 4:分拣中 5:已分拣(待包装) 6:包装中 7:包装完成 8:已取消
        {selected: true, value: null, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {selected: false, value: 5, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001809')},
        {selected: false, value: 6, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004683')},
        {selected: false, value: 7, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004684')}
      ],
      dropDownTimeList: [],
      defaultSelectTimeValue: 1,
      selectTableData: [],
      tableData: [],
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004685'),
          key: 'code',
          align: 'center',
          minWidth: 200
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002387'),
          key: 'ymsContainerCodes',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let text = '-';
            let ymsContainerCodes = params.row.ymsContainerCodes || [];
            if (ymsContainerCodes.length > 0) {
              text = ymsContainerCodes.join('、');
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004686'),
          key: 'status',
          align: 'center',
          minWidth: 110,
          render(h, params) {
            let status = params.row.status;
            let text = getEnumName(v.enumData, 'YmsPickingOrderStatusCoreEnum', status);
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390'),
          key: 'warehouseName',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004687'),
          key: 'packageQuantity',
          align: 'center',
          minWidth: 100
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004062'),
          key: 'skuNumber',
          align: 'center',
          minWidth: 100
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004688'),
          key: 'packageGoodsType',
          align: 'center',
          minWidth: 110,
          render(h, params) {
            let packageGoodsType = Number(params.row.packageGoodsType);
            let packageGoodsTypeList = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000203'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000202')];
            let text = packageGoodsTypeList[packageGoodsType - 1] || '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004689'),
          align: 'center',
          width: 180,
          key: 'sortedTime',
          render(h, params) {
            let sortedTime = params.row.sortedTime;
            return h('span', v.$uDate.dealTime(sortedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004690'),
          align: 'center',
          minWidth: 130,
          key: 'sortedBy',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.sortedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054'),
          key: 'startTime',
          align: 'center',
          width: 180,
          render(h, params) {
            let startTime = params.row.startTime;
            return h('span', v.$uDate.dealTime(startTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004057'),
          key: 'endTime',
          align: 'center',
          width: 180,
          render(h, params) {
            let endTime = params.row.endTime;
            return h('span', v.$uDate.dealTime(endTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004691'),
          align: 'center',
          minWidth: 110,
          key: 'operatorId',
          render(h, params) {
            return h('div', getUserNameByUserId(params.row.operatorId, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004692'),
          key: 'source',
          align: 'center',
          minWidth: 110,
          render(h, params) {
            let source = Number(params.row.source);
            let text = getEnumName(v.enumData, 'YmsPickingOrderSourceCoreEnum', source, 'number');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          fixed: 'right',
          align: 'center',
          width: 110,
          render(h, params) {
            let sortedBy = params.row.sortedBy;
            let status = params.row.status;
            let code = params.row.code;
            return h('optsButtonList', { // // 3:待分拣 4:分拣中 5:已分拣(待包装) 6:包装中 7:包装完成 8:已取消
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004693'),
                    show: status === 5,
                    clickFn: () => {
                      v.pickList = code;
                      setTimeout(() => {
                        v.pickStart();
                      }, 400);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004210'),
                    show: status === 6 && v.userInfo.userId === sortedBy,
                    clickFn: () => {
                      let path = v.packagingTab === 'conventionalPackaging' ? '/packingWork' : '/choicePackingWork';
                      v.$router.push({
                        path: path,
                        query: {
                          code: code
                        }
                      });
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      exportType: null,
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'code', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004694')},
            {paramKey: 'ymsContainerCode', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002387')},
            {paramKey: 'statusStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004686')},
            {paramKey: 'ymsWarehouseName', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390')}`},
            {paramKey: 'packageQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004687')},
            {paramKey: 'skuNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004062')},
            {paramKey: 'packageGoodsTypeStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004688')},
            {paramKey: 'pickedSortedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004689')},
            {paramKey: 'pickedSortedBy', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004690')},
            {paramKey: 'startTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004054')},
            {paramKey: 'endTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004057')},
            {paramKey: 'operatorName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004695')},
            {paramKey: 'sourceStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004692')},
          ]
        }
      ],
      originalDropDownTimeList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004689'), value: 1, parameterKey: ['sortedStartTime', 'sortedEndTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004696'), value: 2, parameterKey: ['beginPackingStartTime', 'beginPackingEndTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004697'), value: 3, parameterKey: ['closePackingStartTime', 'closePackingEndTime']}
      ],
      userInfoList: {},
      enumData: []
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  mounted() {
    let v = this;
    v.$nextTick(() => {
      v.getFocus('packaging');
    });
  },
  created() {
    if ([7, null].includes(this.pageParams.status)) {
      this.setDefaultTimerParams('three_months', 1);
    }
    this.getWorkProgress().then((data) => {
      this.workModal(data);
    });
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      if (v.getPermission('ymsPickingOrder_queryPackingListByParam')) {
        v.warehouseList = [];
        (async () => {
          let enumKeyList = [
            'YmsPickingOrderSourceCoreEnum',
            'YmsPickingOrderStatusCoreEnum'
          ];
          v.enumData = await getDataSetBatchList(enumKeyList);
          await getAllUsersInfo().then((data) => {
            v.userInfoList = data;
          });
          // 查询商户下拥有所有授权仓库的用户
          await getYmsUserWarehouseOpersUserName(v.userInfo.userId).then((data) => {
            if (data) {
              for (let key in data) {
                v.updatedByList.push(data[key]);
              }
            }
          });
          await getEnableWarehouseData(1).then((data) => {
            v.warehouseList = data;
            v.warehouseList.unshift({
              ymsWarehouseId: 'null',
              name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
            });
          });
          await v.search();
        })();
      }
    },
    // 正在作业的提示框
    workModal(data) {
      let v = this;
      let pickinglistNo = '';
      if (data) {
        // 6 包装中
        if (data.status === 6) {
          pickinglistNo = data.code;
          let title = v.packagingTab === 'conventionalPackaging' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004698') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004699');
          v.$Modal.confirm({
            title: title,
            content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004681')}${pickinglistNo}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004682')}`,
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004210'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
            onOk: () => {
              let path = v.packagingTab === 'conventionalPackaging' ? '/packingWork' : '/choicePackingWork';
              v.$router.push({
                path: path,
                query: {
                  code: data.code
                }
              });
            },
            onCancel: () => {
              v.pickList = '';
              v.getFocus('packaging');
            }
          });
        }
      } else {
        v.pickList = '';
        v.getFocus('packaging');
      }
    },
    // 查询当前常规包装是否有正在进行中的作业
    getWorkProgress(code) {
      let v = this;
      let url = '';
      if (code) {
        url = api.put_ymsPickingOrder_startPacking + '?code=' + code;
      } else {
        url = api.put_ymsPickingOrder_startPacking;
      }
      return new Promise((resolve) => {
        v.axios.put(url, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004700')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            resolve(data);
          }
        });
      });
    },
    // 查询当前备货包装是否有正在进行中的作业
    getChoiceWorkProgress(code) {
      let v = this;
      let url = '';
      if (code) {
        url = api.put_ymsPickingOrder_startPackingForThirdPlatform + '?code=' + code;
      } else {
        url = api.put_ymsPickingOrder_startPackingForThirdPlatform;
      }
      return new Promise((resolve) => {
        v.axios.put(url, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004700')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            resolve(data);
          }
        });
      });
    },
    // 开始拣货复核
    pickStart() {
      let v = this;
      if (v.pickList) {
        // 常规包装
        if (v.packagingTab === 'conventionalPackaging') {
          v.getWorkProgress().then((data) => {
            if (data) {
              if (data.status === 6) {
                v.workModal(data);
              }
            } else {
              v.getWorkProgress(v.pickList).then((data) => {
                if (data) {
                  if (data.status !== 6) {
                    if (v.getPermission('ymsPickingOrder_startPacking')) {
                      v.$router.push({
                        path: '/packingWork',
                        query: {
                          code: v.pickList
                        }
                      });
                    } else {
                      v.gotoError();
                    }
                  }
                }
              });
            }
          });
        }
        // 备货包装
        else {
          v.getChoiceWorkProgress().then((data) => {
            if (data) {
              if (data.status === 6) {
                v.workModal(data);
              }
            } else {
              v.getChoiceWorkProgress(v.pickList).then((data) => {
                if (data !== 6) {
                  if (v.getPermission('ymsPickingOrder_startPackingForThirdPlatform')) {
                    v.$router.push({
                      path: '/choicePackingWork',
                      query: {
                        code: v.pickList
                      }
                    });
                  } else {
                    v.gotoError();
                  }
                }
              });
            }
          });
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004701'));
        return false;
      }
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.pickingStatusBtn(0, null);
      v.changeTimeInput(1);
      if ([7, null].includes(v.pageParams.status)) {
        v.setDefaultTimerParams('three_months', 1);
      }
      v.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let keyList = ['ymsWarehouseId', 'operatorId'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : v.pageParams[key];
      }
      for (let key in params) {
        if (['codes'].includes(key)) {
          params[key] = v.sepCommasFn(params[key], ['\n']);
        }
      }
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.optionBtnWidth = [];
      if (v.getPermission('ymsPickingOrder_queryPackingListByParam')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsPickingOrder_queryPackingListByParam, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.updateTableDom('selection');
            }
          } else {
            v.tableLoading = false;
          }
        });
      }
    },
    // 选取订单状态
    pickingStatusBtn(index, value) {
      let v = this;
      v.pageParams.status = value;
      v.pickingStatusList.forEach((n, i) => {
        n.selected = i === index;
      });
      if ([7, null].includes(v.pageParams.status)) {
        v.setDefaultTimerParams('three_months', 1);
      } else {
        v.changeTimeInput(1);
      }
    },
    // 获取选中的时间
    selectTime(data) {
      let v = this;
      let time = data.date;
      let timeList = v.defaultTimePeriod(time);
      let current = data.value;
      v.dropDownTimeList.map((item) => {
        if (item.value === current) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          v.$nextTick(() => {
            v.$refs['dropDownDateTime'].timeList = v.defaultTimePeriod(time, false);
          });
          v.pageParams[startTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams[endTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      });
    },
    // 改变默认时间筛选下拉选项的值
    changeTimeInput(value) {
      this.defaultSelectTimeValue = value;
      this.$refs['dropDownDateTime'].timeList = [];
      this.dropDownTimeList.map((item) => {
        let startTimeKey = item.parameterKey[0];
        let endTimeKey = item.parameterKey[1];
        this.pageParams[startTimeKey] = null;
        this.pageParams[endTimeKey] = null;
      });
    },
    // 重置选中的时间
    resetTime(value) {
      this.dropDownTimeList.map((item) => {
        if (item.value === value) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          this.pageParams[startTimeKey] = null;
          this.pageParams[endTimeKey] = null;
        }
      });
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data && data.length > 0) {
        this.selectTableData = data.map((item) => {
          return item.ymsPickingOrderId;
        });
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsPickingOrderIds = v.selectTableData;
      } else {
        query.ymsPickingOrderIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          v.axios.post(api.post_ymsPickingOrder_exportPackingListByParam, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 切换tab
    changeTab(value) {
      let v = this;
      if (value === 'conventionalPackaging') {
        v.pageParams.pageNum = 1;
        v.pageParams.packingType = 1;
        v.pageParamsStatus = true;
        v.getWorkProgress().then((data) => {
          v.workModal(data);
        });
      } else if (value === 'stockUpPackaging') {
        v.pageParams.pageNum = 1;
        v.pageParams.packingType = 2;
        v.pageParamsStatus = true;
        v.getChoiceWorkProgress().then((data) => {
          v.workModal(data);
        });
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    'pageParams.status': {
      handler(val) {
        if (val === 5) {
          this.dropDownTimeList = this.originalDropDownTimeList.filter((item) => {
            return item.value == 1;
          });
        } else if (val === 6) {
          this.dropDownTimeList = this.originalDropDownTimeList.filter((item) => {
            return item.value !== 3;
          });
        } else {
          this.dropDownTimeList = this.originalDropDownTimeList;
        }
        this.$forceUpdate();
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  font-size: 22px;
  color: #333;
  font-weight: bold;
  margin-bottom: 15px;
}

.tabs_styles {
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
    background-color: #fff;
    padding: 8px 0 3px 10px;
    margin: 0;
  }
}
</style>
